import React from 'react'

function ForgotPassword() {
  return (
    <div>
      <h1>forgot password</h1>
    </div>
  )
}

export default ForgotPassword
